import { action } from '@ember/object';
import CommunicationsMessageLogListControllerBase from 'garaje/helpers/communications/message-log/list/controller-base';

export default class CommunicationsMessageLogListGlobalOverviewController extends CommunicationsMessageLogListControllerBase {
  @action
  navigateToSendMessagePage(): void {
    void this.router.transitionTo('communications.message-log.new');
  }
}
